/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import {
  Component, Inject, Watch, Mixins,
  Prop,
} from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { ChannelCreditStatusEnum } from '@/api/apply-product/types';
import type {
  ApplyChannelData,
  ApplyProductData,
  ProductCapitalItem,
} from '@/api/apply-product/types';
import { RouterV2Enum } from '@/router/router-names';
import { FormInfomation } from '@/views_v2/card-list/types';
import FinanceBusiness from '@/mixins/finance-business';
import type { LoanBankCard, ValidateFunction } from '../../types';

// eslint-disable-next-line @typescript-eslint/no-unsafe-return
const SelectBankcardCom = () => import(
  /* webpackChunkName: "select-bank-card" */'@/components/select-bank-card'
// eslint-disable-next-line @typescript-eslint/no-explicit-any
) as any;

const ApplyProductStore = namespace('applyProduct');

@Component
export default class SelectBankcard extends Mixins(
  FinanceBusiness,
) {
  @Prop(Object) quickBindCardResult?: Dictionary;

  @ApplyProductStore.State bankCard!: LoanBankCard;

  @ApplyProductStore.State channel!: ApplyChannelData;

  @ApplyProductStore.State product!: ApplyProductData;

  @ApplyProductStore.State isVisibleLoading!: boolean;

  @ApplyProductStore.State h5BioSuc!: boolean;

  @ApplyProductStore.State selectRightInCapital!: ProductCapitalItem | null;

  @ApplyProductStore.State selectCapitalChangedForBank!: boolean;

  @ApplyProductStore.Getter isSimplifiedListStyle!: boolean;

  @ApplyProductStore.Action $updateState!: (data: Dictionary) => void;

  @Inject() readonly registValidator!: (valid: ValidateFunction) => void;

  // 是否显示银行卡切换弹窗
  private showChannelChangeDialog = false;

  @Watch('product')
  private onProductChange(
    newProduct: ApplyProductData,
    oldProduct: ApplyProductData,
  ) {
    const currentBankCard = this.bankCard;
    const newBankCard = this.getLoanBankCardFromProduct(this.product);
    const updateBankCard = () => {
      // 已经选择了银行卡 且 新渠道 没有绑定默认的银行卡，则显示弹窗提醒用户关注需要绑定新的银行卡
      if (
        currentBankCard
        && !this.showChannelChangeDialog
        && !newBankCard
      ) {
        // 将未绑卡渠道银行卡置空
        this.$updateState({
          bankCard: undefined,
        });
      } else {
        this.$updateState({
          bankCard: newBankCard,
        });
      }
    };
    const newProductAvailable = newProduct && newProduct.productInfo;

    if (!oldProduct) {
      // 初始化状态下选中了默认渠道
      this.$updateState({
        bankCard: (this.h5BioSuc || this.quickBindCardResult) ? currentBankCard : newBankCard,
      });
    } else if (
      // 当前渠道额度可用，确保当前选择的渠道与银行卡对应(网络延迟)
      newProductAvailable
      && oldProduct.productInfo.productId !== newProduct.productInfo.productId
      && this.channel.creditStatus === ChannelCreditStatusEnum.SUCCEEDED
    ) {
      updateBankCard();
    } else if (
      newProductAvailable
      /* 双融担模式下，tab切换资方时，同步更新银行卡 */
      && this.selectRightInCapital
      && newProduct.productInfo.productId === this.selectRightInCapital.productId
      && this.selectCapitalChangedForBank
    ) {
      this.$updateState({
        selectCapitalChangedForBank: false,
      });
      updateBankCard();
    }
  }

  private render() {
    if (this.bankCard) {
      /** 提现页面_银行卡栏曝光 TODO: 这里也会上报两次 */
      this.$ubtModuleExposeNew('finance_loan_apply_cardCategory', {
        productId: this.channel.productId,
      });
      return (
        <div>
          { this.bankCard && <SelectBankcardCom
            isDisplayLoading={this.isVisibleLoading}
            name={this.isSimplifiedListStyle ? '收款卡' : '收款账户'}
            subName={this.isSimplifiedListStyle ? '' : '预计两小时到账'}
            bankInfo={this.bankCard}
            onClick={this.onSelectCard.bind(this)}
          /> }
        </div>
      );
    }
    return (
      <div></div>
    );
  }

  // 获取默认的收款银行卡
  private getLoanBankCardFromProduct(
    product: ApplyProductData,
  ): LoanBankCard | undefined {
    const userData = product ? product.userCredit : undefined;
    if (userData && userData.bankName) {
      return {
        bankName: userData.bankName,
        bankNo: userData.bankNo,
        bankIcon: userData.bankIconUrl,
        bankId: userData.userBankCardId,
      };
    }

    return undefined;
  }

  private onSelectCardOnProductChange() {
    this.$ubtPageButton(
      '臻有钱_提现申请_重新绑定银行卡',
      '产品',
      this.channel && this.channel.productId,
    );

    this.showChannelChangeDialog = false;
    this.goSelectPage();
  }

  private onResetOnProductChange() {
    this.$ubtPageButton(
      '臻有钱_提现申请_取消绑定银行卡',
      '产品',
      this.channel && this.channel.productId,
    );

    this.showChannelChangeDialog = false;
  }

  // 选择提现收款银行卡
  private onSelectCard() {
    this.$ubtPageButton(
      '臻有钱_提现申请_到账银行卡',
      '产品',
      this.channel && this.channel.productId,
    );
    this.goSelectPage();
  }

  // 自营 B 渠道 资方code
  private get capitalCode() {
    return (this.channel && this.channel.capitalCode) || '';
  }

  public goSelectPage(): void {
    /** 进入银行绑卡前的数据缓存 */
    this.$emit('handleBeforeGoCardList');

    this.$router.push({
      path: RouterV2Enum.cardList,
      query: {
        from: FormInfomation.Product,
        commodityId: this.channel && this.channel.productId,
        capitalCode: this.capitalCode,
        isPreCredit: String(this.channel.preCredit),
        ocrAfterLoan: String(this.channel.ocrAfterLoan),
      },
    });
  }
}
